import { inputBaseClasses } from "@mui/material"
import { blueGrey } from "../../../../mp-core/themes/palette"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing }) => ({
  editableTextContainer: {
    width: "fit-content",
    cursor: "pointer",

    "& .material-icons": {
      opacity: "0"
    },

    "&:hover": {
      "& .material-icons": {
        opacity: "1"
      }
    }
  },
  editTextInput: {
    [`& .${inputBaseClasses.input}`]: {
      color: blueGrey[800],
      fontSize: "1rem",
      lineHeight: "1.375rem",
      padding: spacing(0),
      borderBottom: `1px solid ${blueGrey[200]}`
    }
  },
  visibleEditIcon: {
    opacity: "1 !important"
  }
}))
